<template>
  <create-target-slot
    :title="text"
    :overrideLoad="appendTypeIsNpowerOrComscore"
    :showBackButton="showBackButton"
    :svg="svg"
    :png="png"
  >
    <template v-if="appendTypeIsNpowerOrComscore">
      <append-n-power-form class="upload-modal__upload-options" />
    </template>
    <template v-else-if="showSelectSegment">
      <select-segment-modal
        slot="select"
        :onCompleteSegmentUpload="onComplete"
        :segmentData="segmentData"
        :uploadedTargetId="uploadedTargetId"
        :uploadedTargetViewingStream="uploadedTargetViewingStream"
      ></select-segment-modal>
    </template>
    <template v-else-if="showOverwrites">
      <overwrite-form
        :overwrites="overwrites"
        :onComplete="onComplete"
        :targetId="uploadedTargetId"
      />
    </template>
    <template v-else-if="showCreateNewUpload">
      <create-upload
        :defaultSelectedUpload="defaultSelectedUpload"
        :originalTarget="originalTarget"
        :onCompleteUpload="onCompleteUpload"
        :onComplete="onComplete"
        @submittedUploadFile="submittedUploadFile"
        @sentDownstream="sentDownstream"
      />
    </template>
    <template v-else-if="showAppendNewFile">
      <append-file-uploader
        ref="appendFile"
        :defaultAppendOption="defaultAppendingOption"
        :defaultSelectedTarget="defaultSelectedAppendingTarget"
        :onCompleteUpload="onCompleteUpload"
      />
    </template>
  </create-target-slot>
</template>

<script>
  import CreateUpload from '../forms/CreateUpload'
  import AppendFileUploader from '../forms/AppendFileUploader'
  import uploadIcon from '@/assets/targetImages/upload.svg'
  import xandrIcon from '@/assets/dataSources/Xandr-Selected.png'
  import SelectSegmentModal from '@/appComponents/targets/createTarget/forms/NpowerSelectSegmentModal'
  import OverwriteForm from '@/appComponents/targets/createTarget/forms/PidOverwriteForm'
  import AppendNPowerForm from '@/appComponents/targets/createTarget/forms/AppendNPowerForm'
  import { TARGET_TYPE } from '@/appLogic/targets/Constants'
  import { UPLOAD_MODAL_SET_APPEND_TYPE } from '@/appLogic/targets/createTarget/store/actions'
  import RadioButtons from '@/components/common/radioButtons'
  import { deleteTargetResource } from '@/api'
  import CreateTargetSlot from './CreateTargetSlot'

  const UPLOAD_OPTIONS = [
    {
      value: '1',
      name: 'Create New Target',
    },
    {
      value: '2',
      name: 'Append File',
    },
  ]

  export default {
    components: {
      SelectSegmentModal,
      CreateUpload,
      RadioButtons,
      AppendFileUploader,
      OverwriteForm,
      CreateTargetSlot,
      AppendNPowerForm,
    },
    props: {
      onComplete: {
        type: Function,
        default: () => {},
      },
      defaultSelectedUpload: {
        type: String,
        default: null,
      },
      showBackButton: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      // fff helps with suplying data for overwrites
      const fff = JSON.parse(
        '{"bucket":"am-target-files-dev","existing_files":[{"exists":true,"year_month":"year_month=2017_12"},{"exists":true,"year_month":"year_month=2018_02"},{"exists":true,"year_month":"year_month=2018_01"},{"exists":true,"year_month":"year_month=2017_04"},{"exists":true,"year_month":"year_month=2017_05"},{"exists":true,"year_month":"year_month=2017_08"},{"exists":true,"year_month":"year_month=2017_06"},{"exists":true,"year_month":"year_month=2017_09"},{"exists":true,"year_month":"year_month=2017_07"},{"exists":true,"year_month":"year_month=2017_10"},{"exists":true,"year_month":"year_month=2018_03"},{"exists":true,"year_month":"year_month=2017_11"}],"key":"PIDFiles/e2203af3-e808-477f-a7cc-60f8eb533dfb/stuff__2018-10-10-003624____13994.csv"}',
      )
      return {
        segmentData: null,
        // uploadedTargetId: '37a425b0-f56a-4d34-aab4-ba30be28f892',
        uploadedTargetId: null,
        uploadedTargetViewingStream: null,
        uploadOptions: UPLOAD_OPTIONS,
        uploadOption: UPLOAD_OPTIONS[0].value,
        appendingPID: null,
        defaultAppendingOption: null,
        defaultSelectedAppendingTarget: null,
        // overwrites: fff
        overwrites: null,
      }
    },
    computed: {
      nielsenDatasources() {
        return this.$store.getters.getNielsenDatasources
      },
      text() {
        if (this.originalTarget && this.initialTargetAction) {
          if (this.originalTarget.target_datasource === this.nielsenDatasources.ATTDIRECTTV) {
            return `${this.initialTargetAction} Xandr-File Target`
          }
          return `${this.initialTargetAction} File Upload Target`
        } else {
          // Dont think that there is going to be a update with this Option
          return 'New File Upload Target'
        }
      },
      svg() {
        if (this.originalTarget && this.originalTarget.target_datasource === this.nielsenDatasources.ATTDIRECTTV) {
          return undefined
        }
        return uploadIcon
      },
      png() {
        if (this.originalTarget && this.originalTarget.target_datasource === this.nielsenDatasources.ATTDIRECTTV) {
          return xandrIcon
        }
        return undefined
      },
      defaultCreateUploadModalOptions() {
        return this.$store.state.createTarget.uploadModalOptions
      },
      showCreateNewUpload() {
        return UPLOAD_OPTIONS[0].value === this.uploadOption
      },
      showAppendNewFile() {
        return UPLOAD_OPTIONS[1].value === this.uploadOption
      },
      showUploads() {
        return !(this.segmentData || this.overwrites)
      },
      showSelectSegment() {
        return Boolean(this.segmentData)
      },
      showOverwrites() {
        return this.overwrites
      },
      appendType() {
        return this.$store.state.createTarget.appendType
      },
      appendTypeIsNpowerOrComscore() {
        return this.appendType === TARGET_TYPE.NPOWER || this.appendType === TARGET_TYPE.COMSCORE
      },
      originalTarget() {
        if (this.$store.state.createTarget.initialTarget) {
          return {
            ...(this.$store.state.createTarget.initialTarget || {}),
            display_name: this.targetName || (this.$store.state.createTarget.initialTarget || {}).display_name || '',
          }
        }

        return undefined
      },
      initialTargetAction() {
        return this.$store.state.createTarget.initialTargetAction
      },
    },
    methods: {
      finish() {
        if (this.overwrites) {
          // TODO need to call the api to delete the target resource
          deleteTargetResource({ target_id: this.uploadedTargetId })
        }
        this.onComplete()
        this.segmentData = null
        this.uploadedTargetId = null
        this.uploadedTargetViewingStream = null
        this.overwrites = null
        this.appendingPID = null
        this.defaultSelectedAppendingTarget = null
        this.defaultAppendingOption = null
        this.uploadOption = UPLOAD_OPTIONS[0].value
        this.$store.dispatch(UPLOAD_MODAL_SET_APPEND_TYPE, null)
      },
      onCompleteUpload(target, uploadResult) {
        // uploadResult is only for PID overwrites
        const isNpower = target.target === TARGET_TYPE.NPOWER
        const isComscore = target.target === TARGET_TYPE.COMSCORE
        const isNpowerWithUploadResults = isNpower && Boolean(uploadResult)
        const isComscoreWithUploadResults = isComscore && Boolean(uploadResult)
        const isPidTargetWithOverwrites = target.target === TARGET_TYPE.PID && uploadResult
        if (!isNpowerWithUploadResults && !isComscoreWithUploadResults && !isPidTargetWithOverwrites) {
          this.finish()
        } else if (isNpowerWithUploadResults || isComscoreWithUploadResults) {
          this.segmentData = uploadResult.irisResponse
          this.uploadedTargetId = uploadResult.target.id
          this.uploadedTargetViewingStream = uploadResult.target.viewing_stream
          this.$forceUpdate()
        } else if (isPidTargetWithOverwrites) {
          this.overwrites = uploadResult.data.existing_files
          this.appendingPID = uploadResult
          this.uploadedTargetId = uploadResult.target.id
          this.uploadedTargetViewingStream = uploadResult.target.viewing_stream
        }
      },
      setUploadOptions() {
        this.uploadOption = this.defaultCreateUploadModalOptions.type
        this.defaultAppendingOption = this.defaultCreateUploadModalOptions.appendingOption
        this.defaultSelectedAppendingTarget = this.defaultCreateUploadModalOptions.target
      },
      submittedUploadFile() {
        this.$emit('submittedUploadFile')
      },
      sentDownstream() {
        this.finish()
      },
    },
    mounted() {
      if (this.defaultSelectedUpload) {
        this.defaultAppendingOption = this.defaultSelectedUpload
      }
      if (this.defaultCreateUploadModalOptions) {
        this.setUploadOptions()
      }
    },
    watch: {
      defaultCreateUploadModalOptions() {
        this.setUploadOptions()
      },
      defaultSelectedUpload() {
        this.defaultAppendingOption = this.defaultSelectedUpload
        this.defaultSelectedAppendingTarget = this.defaultSelectedUpload
      },
    },
  }
</script>

<style lang="scss">
  .upload-modal {
    &__upload-options {
      margin: 0 auto;
      text-align: center;
      color: #444444;
    }
  }
</style>



// WEBPACK FOOTER //
// UploadTargetSlot.vue?69030568